import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { init } from '@siloreal:app:config/init/init';

import { oldRoutes } from '@old/navigation/routes';
import { newRoutes } from '@siloreal:app:routes/route-config';

// import * as CFG from '@siloreal:app:config'; // Usar para CFG.env.is.DEV en lugar de import.meta.env.VITE_MODE === 'DEV'

import './old/index.css';
import { OldProviders } from '@siloreal:app:providers/providers';

init();

const router = createBrowserRouter([...newRoutes, ...oldRoutes]);

createRoot(document.getElementById('root')!).render(
  <OldProviders>
    <RouterProvider router={router} />
  </OldProviders>
);
